import { TextField } from '@mui/material';
import styled from 'styled-components';

export const DateRangePickerWrapper = styled.div`
  position: relative;
`;

export const DateRangePickerInput = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    height: '42px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    '& fieldset': {
      borderColor: '#e0e0e0',
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: '#d0d0d0',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1976D2',
      borderWidth: '2px',
    },
  },
  '& .MuiInputBase-input': {
    fontSize: '14px',
    fontWeight: 600,
    color: '#333',
    padding: '0 12px',
  },
  '& .MuiInputAdornment-root': {
    color: '#5E8E7E',
  }
}));